import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import About from './pages/About';
import CaseStudies from './pages/CaseStudies';
// Services
import SparringPartner from './pages/services/SparringPartner';
import Architecte from './pages/services/Architecte';
import Pilote from './pages/services/Pilote';
import Coach from './pages/services/Coach';
import Recruteur from './pages/services/Recruteur';
import Accelerateur from './pages/services/Accelerateur';
// Expertises
import Prospection from './pages/expertises/Prospection';
import Discovery from './pages/expertises/Discovery';
import Closing from './pages/expertises/Closing';
import AccountManagement from './pages/expertises/AccountManagement';
import SalesOps from './pages/expertises/SalesOps';
import RecrutementExpertise from './pages/expertises/Recrutement';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            {/* Services */}
            <Route path="/services/sparring" element={<SparringPartner />} />
            <Route path="/services/architecte" element={<Architecte />} />
            <Route path="/services/pilote" element={<Pilote />} />
            <Route path="/services/coach" element={<Coach />} />
            <Route path="/services/recruteur" element={<Recruteur />} />
            <Route path="/services/accelerateur" element={<Accelerateur />} />
            {/* Expertises */}
            <Route path="/expertises/prospection" element={<Prospection />} />
            <Route path="/expertises/discovery" element={<Discovery />} />
            <Route path="/expertises/closing" element={<Closing />} />
            <Route path="/expertises/account-management" element={<AccountManagement />} />
            <Route path="/expertises/sales-ops" element={<SalesOps />} />
            <Route path="/expertises/recrutement" element={<RecrutementExpertise />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
